import {ReactComponent as LoadingIcon} from 'assets/icons/loading.svg';
import styles from './styles.module.scss';
import { FC, Props } from './typings';
import classNames from 'classnames';

const Spinner: FC<Props> = ({className}) => <LoadingIcon className={classNames(styles.icon, className)} />

export default Spinner;